<template>
  <div class="checkbox">
     <span @click="toggleChecked" class="out">
      <iconfont
        :name="checked ? '#icon39121_1':'#icon3912'"
        font-size="14px"
        style="color: #333;"
      ></iconfont>
     </span>
    <span class="checkbox__text" @click="toggleChecked">允许来画展示</span>
    <el-tooltip
      effect="dark"
      placement="bottom"
      :open-delay="2"
    >
      <div slot="content">
        允许后，您的作品将有机会在来画首页<br/>及其他页面展示
      </div>
      <span class="out">
        <iconfont
          name="#icon2111"
          font-size="14px"
          style="color: #333;"
        ></iconfont>
    </span>
    </el-tooltip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    initialChecked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      checked: false,
      ANALYSIS: {
        click_cancel_authorization_agreement: {category:'export_video', action:'click_cancel_authorization_agreement', label:'导出_取消选中作品展示授权'},
        click_authorization_agreement: {category:'export_video', action:'click_authorization_agreement', label:'导出_重新选中作品展示授权'},
      }
    }
  },
  computed: {
    ...mapGetters([
      "UserMsg"
    ]),
  },
  components: {
    iconfont: () => import('@/platformCode/iconfont')
  },
  created () {
    // this.checked = this.initialChecked;
    this.updateAgreeShow();
  },
  methods: {
    getChecked () {
      return this.checked;
    },
    toggleChecked () {
      this.checked = !this.checked;
      const id = this.UserMsg.id;
      this.setLocalAgreeShow(id, this.checked);
      if (this.checked) {
        this.$analysis(this.ANALYSIS.click_authorization_agreement);
      } else {
        this.$analysis(this.ANALYSIS.click_cancel_authorization_agreement);
      }
    },
    getCheckedNum () {
      return this.checked ? 1 : 0;
    },
    getLocalAgreeShow (id = 0) {
      const str = localStorage.getItem('local.agreeShow') || '{}';
      const dict = JSON.parse(str);
      return dict[id];
    },
    setLocalAgreeShow (id = 0, value) {
      const str = localStorage.getItem('local.agreeShow') || '{}';
      const dict = JSON.parse(str);
      dict[id] = value;
      localStorage.setItem('local.agreeShow', JSON.stringify(dict));
    },
    updateAgreeShow () {
      const id = this.UserMsg.id;
      let agreed = this.getLocalAgreeShow(id);
      if (agreed == null) {
        this.setLocalAgreeShow(id, true);
        agreed = this.getLocalAgreeShow(id);
      }
      this.checked = agreed;
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
  align-items: center;
  justify-content: center;

  &__icon {
    cursor: pointer;
  }

  &__text {
    padding-left: 4px;
    padding-right: 8px;
    cursor: pointer;
  }
  &__suffix {
    transform: scale(1.2);
  }
  .out {
    position: relative;
    top: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/checkboxShare.vue